import React from 'react';
import { Paper } from '@mui/material';

interface DataTableContainerProps {
  totalWidth: number;
  maxHeight?: string;
  children: React.ReactNode;
}

/**
 * Container component for scrollable table with fixed-width layout.
 * Handles horizontal and vertical scrolling while maintaining fixed column widths.
 *
 * @example
 * <DataTableContainer totalWidth={calculateTableWidth(visibleColumns)}>
 *   <Table>...</Table>
 * </DataTableContainer>
 */
const DataTableContainer: React.FC<DataTableContainerProps> = ({
  totalWidth,
  maxHeight = '70vh',
  children,
}) => {
  return (
    <Paper
      sx={{
        mb: 3,
        display: 'flex',
        flexDirection: 'column',
        maxHeight,
        maxWidth: '100%',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          overflowY: 'auto',
          overflowX: 'auto',
          flex: '1 1 auto',
          WebkitOverflowScrolling: 'touch',
          position: 'relative',
          maxWidth: '100%',
          minHeight: 0,
        }}
      >
        {children}
      </div>
    </Paper>
  );
};

export default DataTableContainer;
